//ReportPage.jsx

import { useParams } from "react-router-dom";
import AppLayout from "../layout/AppLayout";

export default function ReportPage() {
    const { jobId } = useParams();

    return <AppLayout initialJobId={jobId || null} />;
}